export default "__VITE_ASSET__DaH73IR4__"